"use client";

import Link from "next/link";
import clsx from "clsx";
import { hardcodedContent } from "@/app/(site)/_lib/global-content";
import { useCompanyData, useSocialMediaData } from "@/app/(site)/_hooks/useSanityData";
import { getNavItems, LABELS, ROUTES } from "@/app/(site)/_lib/routes";

export default function FooterColsText() {
	const { companyInfo } = useCompanyData();
	const { socialMedia } = useSocialMediaData();
	const navItems = getNavItems();

	return (
		<>
			<div className="pt-[3.313rem] sm:pt-0">
				<div className="flex flex-col gap-y-2">
					<p className="text-cap-m sm:text-graphite-black text-white">{hardcodedContent.footerWhiteBlock.contact}</p>
					{companyInfo.email && (
						<p className="text-cap-m sm:text-graphite-black/50 sm:hover:text-graphite-black sm:active:text-graphite-black text-white/50 transition-colors duration-300 hover:text-white active:text-white">
							<a href={`mailto:${companyInfo.email}`} className="w-fit">
								{companyInfo.email}
							</a>
						</p>
					)}
					{companyInfo.addressContent && (
						<>
							{companyInfo.addressContent.lineOne && (
								<p className="text-cap-m sm:text-graphite-black/50 text-white/50">{companyInfo.addressContent.lineOne}</p>
							)}
							{companyInfo.addressContent.lineTwo && (
								<p className="text-cap-m sm:text-graphite-black/50 text-white/50">{companyInfo.addressContent.lineTwo}</p>
							)}
							{companyInfo.addressContent.lineThree && (
								<p className="text-cap-m sm:text-graphite-black/50 text-white/50">{companyInfo.addressContent.lineThree}</p>
							)}
						</>
					)}
				</div>
				<div className="mt-10 hidden sm:block">
					<p className="text-cap-s text-graphite-black/50">©{new Date().getFullYear()} ALL RIGHTS RESERVED.</p>
				</div>
			</div>
			<div className="">
				<div className="flex flex-col gap-y-2">
					<p className="text-cap-m sm:text-graphite-black text-white">{hardcodedContent.footerWhiteBlock.seeMore}</p>
					<ul className="flex flex-col gap-y-2">
						{navItems.map((item) => {
							return (
								<li key={item.href} className="w-fit">
									<Link
										key={item.href}
										href={item.href}
										className={clsx(
											"text-cap-m text-brown-middle hover:text-brown active:text-brown block transition-colors duration-300",
										)}
									>
										{item.label}
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
				<div className="mt-10 hidden sm:block">
					<Link
						href={ROUTES.PRIVACY_POLICY}
						className="text-cap-s text-brown-middle hover:text-brown active:text-brown block w-fit transition-colors duration-300"
					>
						{LABELS.privacyPolicy}
					</Link>
				</div>
			</div>
			<div className="">
				<div className="flex flex-col gap-y-2">
					<p className="text-cap-m sm:text-graphite-black text-white">{hardcodedContent.footerWhiteBlock.follow}</p>
					<ul className="flex flex-col gap-y-2">
						{socialMedia.map((item) => {
							return (
								<li key={item.name} className="w-fit">
									<Link
										href={item.link}
										className="text-cap-m text-brown-middle hover:text-brown active:text-brown block transition-colors duration-300"
									>
										{item.name}
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
				<div className="mt-10 hidden items-center sm:flex">
					<span className="text-cap-s text-graphite-black/70">Design by</span>
					<span className="text-cap-s text-graphite-black/70 mx-1">:</span>
					<span className="text-cap-s text-brown-middle hover:text-brown active:text-brown block transition-colors duration-300">
						<a href="https://247studio.com" target="_blank" rel="noopener noreferrer" className="w-fit">
							247®STUDIO
						</a>
					</span>
				</div>
			</div>
			<div className="flex flex-col gap-y-1.5 sm:hidden">
				<Link
					href={ROUTES.PRIVACY_POLICY}
					className="text-cap-s text-brown-middle hover:text-brown active:text-brown block w-fit transition-colors duration-300"
				>
					{LABELS.privacyPolicy}
				</Link>
				<div className="">
					<p className="text-cap-s text-white/50">©{new Date().getFullYear()} ALL RIGHTS RESERVED.</p>
				</div>
				<div className="flex">
					<span className="text-cap-s text-white/50">Design by</span>
					<span className="text-cap-s mx-1 text-white/50">:</span>
					<span className="text-cap-s text-brown-middle hover:text-brown active:text-brown block transition-colors duration-300">
						<a href="https://247studio.com" target="_blank" rel="noopener noreferrer" className="w-fit">
							247®STUDIO
						</a>
					</span>
				</div>
			</div>
		</>
	);
}
